import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { useCallback, useEffect, useState } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { Tooltip } from './styles/range-control-styles';
var TOOLTIP_OFFSET_HEIGHT = 32;
export default function SimpleTooltip(_ref) {
  var className = _ref.className,
      inputRef = _ref.inputRef,
      _ref$position = _ref.position,
      positionProp = _ref$position === void 0 ? 'auto' : _ref$position,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$renderTooltipCon = _ref.renderTooltipContent,
      renderTooltipContent = _ref$renderTooltipCon === void 0 ? function (v) {
    return v;
  } : _ref$renderTooltipCon,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 100 : _ref$zIndex,
      restProps = _objectWithoutProperties(_ref, ["className", "inputRef", "position", "show", "style", "value", "renderTooltipContent", "zIndex"]);

  var position = useTooltipPosition({
    inputRef: inputRef,
    position: positionProp
  });
  var classes = classnames('components-simple-tooltip', className);

  var styles = _objectSpread(_objectSpread({}, style), {}, {
    zIndex: zIndex
  });

  return createElement(Tooltip, _extends({}, restProps, {
    "aria-hidden": show,
    className: classes,
    position: position,
    show: show,
    role: "tooltip",
    style: styles
  }), renderTooltipContent(value));
}

function useTooltipPosition(_ref2) {
  var inputRef = _ref2.inputRef,
      positionProp = _ref2.position;

  var _useState = useState('top'),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var calculatePosition = useCallback(function () {
    if (inputRef && inputRef.current) {
      var nextPosition = positionProp;

      if (positionProp === 'auto') {
        var _inputRef$current$get = inputRef.current.getBoundingClientRect(),
            top = _inputRef$current$get.top;

        var isOffscreenTop = top - TOOLTIP_OFFSET_HEIGHT < 0;
        nextPosition = isOffscreenTop ? 'bottom' : 'top';
      }

      setPosition(nextPosition);
    }
  }, [positionProp]);
  useEffect(function () {
    calculatePosition();
  }, [calculatePosition]);
  useEffect(function () {
    window.addEventListener('resize', calculatePosition);
    return function () {
      window.removeEventListener('resize', calculatePosition);
    };
  });
  return position;
}
//# sourceMappingURL=tooltip.js.map